import * as buried from '@/buried/index';

export default buried;
